import { useState } from 'react';
import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const SkuField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.sku && touched.sku}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>SKU</FormLabel>
                <Field
                    as={FormikInput}
                    id="sku"
                    name="sku"
                    placeholder="e.g. VOSVC0500-01"
                    maxLength={100}
                    data-walkthroughid={walkthroughIds.createMode.ufSkuInput}
                    error={errors.sku}
                />
                {isHovered && (
                    <FieldToolTip
                        label="8×8 SKU code for this offering."
                        ariaLabel="catalog-sku-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SkuField;
